import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'boxicons/css/boxicons.min.css';

ReactDOM.render(<App />, document.getElementById('root'));